import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const NonbreakingSpaceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NonbreakingSpace",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.25 19.5c-.97 0-1.75.78-1.75 1.75v3.5h-21v-3.5c0-.97-.78-1.75-1.75-1.75S2 20.28 2 21.25v5.25c0 .97.78 1.75 1.75 1.75h24.5c.97 0 1.75-.78 1.75-1.75v-5.25c0-.97-.78-1.75-1.75-1.75M9 14.25h5.25v5.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75v-5.25H23c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75h-5.25V5.5c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v5.25H9c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75"
    })
  }));
};